import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from 'antd';

const Butt = styled(Button)`
    border-radius: 20px;
    /* z-index: 1; */
`;

const Back = styled(Butt)`
    position: absolute !important;
    top: 20px;
    right: 20px;
    background: white;
`;


const MainButton = styled.button`
    /* z-index: 9000; */
    width: fit-content;
    padding: 15px 40px;
    background: ${({ theme, fill, color }) => fill ? theme.color[color] : 'transparent'};
    color: ${({ theme, fill, color }) => fill ? 'white' : theme.color[color]};
    border-radius: 5px;
    border: 1px solid ${({ theme, color }) => color ? theme.color[color] : theme.color.primary};
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    cursor: pointer;
    transition: 0.1s;
    &:hover {
        background: ${({ theme, color, hoverColor }) => theme.color[hoverColor]};
        color: white;
    }
    &:active {
        background: ${({ theme, color, activeColor }) => theme.color[activeColor]};
        color: white;
    }
    &:focus {
        outline: none;
    }
`;

const propTypes = {
    color: PropTypes.string,
    hoverColor: PropTypes.string,
    activeColor: PropTypes.string,
    fill: PropTypes.bool,
}
const defaultProps = {
    color: 'primary',
    hoverColor: 'primaryLight',
    activeColor: 'primaryDark',
    fill: false,
}
const on = (props) => (
    <MainButton {...props}>
        {props.children}
    </MainButton>
);
on.propTypes = propTypes;
on.defaultProps = defaultProps;

Butt.Back = Back;
Butt.on = on;
export { Butt };




// WEBPACK FOOTER //
// ./src/sc-ui/Butt.jsx